import {generateId} from './generateId'
export const setNodeId = (node) => {
  const type = node.getAttr('shapeType')
  if (type === 'rect' || type === 'circle') {
    node.setAttr('id', generateId('shape'))
  } else if (type === 'text') {
    node.setAttr('id', generateId('dataLink'))
  } else if (type === 'eye') {
    node.setAttr('id', generateId('eye'))
  } else if (type === 'group') {
    node.setAttr('id', generateId('group'))
  } else if (type === 'customText') {
    node.setAttr('id', generateId('customText'))
  } else {
    node.setAttr('id', generateId('connector'))
  }
}



// WEBPACK FOOTER //
// ./src/components/schemaFonctionnel/helper/setNodeId.js